/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

/**
 * User: ristekochev
 * Date: 5/6/14
 */
(function ($) {
    "use strict";
    /*globals Tc, doT, SCS, debug */
    /*jshint smarttabs:false */

    Tc.Module.Selectbox = Tc.Module.extend({

        on: function (callback) {
            var $ctx = this.$ctx;

            if(this.isEngagement()) {
                $ctx.find(".customDropDown").sSelect();

                callback();

                return;
            }

            $('select', $ctx).selectBoxIt({
                showFirstOption: false,
                autoWidth: false,
                downArrowIcon: "select_down"
            });

            $('select', $ctx).bind({
                "open": function() {
                    $(this).data("selectBox-selectBoxIt").setOptions({ downArrowIcon: "select_up" });
                },
                "close": function() {
                    $(this).data("selectBox-selectBoxIt").setOptions({ downArrowIcon: "select_down" });
                }

            });

            // PLACEHOLDER REPLACEMENT FOR BROWSERS <IE10
            $('[placeholder]').focus(function() {
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                    input.removeClass('placeholder');
                }
            }).blur(function() {
                    var input = $(this);
                    if (input.val() == '' || input.val() == input.attr('placeholder')) {
                        input.addClass('placeholder');
                        input.val(input.attr('placeholder'));
                    }
                }).blur().parents('form').submit(function() {
                    $(this).find('[placeholder]').each(function() {
                        var input = $(this);
                        if (input.val() == input.attr('placeholder')) {
                            input.val('');
                        }
                    })
                });

            callback();
        },

        /**
         * Check if page is engagement
         * @method isEngagement
         * @return {Boolean}
         */
        isEngagement: function() {
            return $('body').hasClass("engagement");
        }

    });
}(Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/emagazine/clientlibs/publish/js/modules/Tc.Module.Selectbox.js
// module id = 47
// module chunks = 0